import { render, staticRenderFns } from "./editBosuDialog.vue?vue&type=template&id=38f7978e&scoped=true"
import script from "./editBosuDialog.vue?vue&type=script&lang=js"
export * from "./editBosuDialog.vue?vue&type=script&lang=js"
import style0 from "./editBosuDialog.vue?vue&type=style&index=0&id=38f7978e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7978e",
  null
  
)

export default component.exports